const hotDrinks = [
  {
    id: 1,
    name: "Masala Tea",
    description: "Masala chai is a spiced milk tea originating from India. It's a blend of black tea, milk, and a variety of aromatic spices like cardamom, cinnamon, ginger, cloves, and black pepper.",
    price: "£2.20"
  }
];

export default hotDrinks;